export enum CheckPath {
  LoginPage = "loginPage",
  OtpPage = "otpPage",
  DetailsPage = "detailsPage",
}

export enum BtnText {
  Login = "Get OTP",
  OtpVerify = "Continue",
  SubmitDetails = "Proceed",
}

export interface LoginFlowModalProps {
  setModalOpen: (show: boolean) => void;
  setLoginProfileBtnText?: (text: string) => void;
  setUserData?: (data: { name: string; email: string; mobile: string; _id: string }) => void;
  isBooking?: boolean;
  forceDetailsPage?: boolean; // NEW: Force modal to show details page
}
